module.exports = __webpack_public_path__ + "img/power-generator.8b83fde9.svg";